import { utcToZonedTime } from 'date-fns-tz'
import { getOrgRestrainedHours } from '../../../helpers/restaurantHours'

export const minutesUntilClose = (
	restaurant: any,
	orgHours: any,
	allowOrdersOutsideOrgHours: boolean,
	localTimezone: string,
	currTime: any = null
): number | undefined => {
	const { hours } = restaurant

	const orgRestrainedHours = getOrgRestrainedHours(hours, orgHours, allowOrdersOutsideOrgHours)

	if (orgRestrainedHours === null) return undefined // 24/7 open

	const currentTime = currTime !== null ? currTime : utcToZonedTime(new Date(), localTimezone)

	const day = currentTime.getDay()

	const currentTimeMinutes = currentTime.getHours() * 60 + currentTime.getMinutes()

	const todayHours = orgRestrainedHours[day] || { startTimes: [], endTimes: [] }
	const closingTimeMinutes = todayHours.endTimes[0] * 60
	// console.log(`currentTimeMinutes, ${currentTimeMinutes}`)
	// console.log(`closingTimeMinutes, ${closingTimeMinutes}`)
	const minutesUntilClose = closingTimeMinutes - currentTimeMinutes
	// console.log(restaurant.name)
	// console.log(minutesTillClose)
	return minutesUntilClose
}
